import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-x-6 gap-y-2" }
const _hoisted_2 = { class: "text-xs text-gray-500" }


export default {
  __name: 'MarketingStatRow',
  props: { stats: { type: Array, required: true } },
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("dl", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stats, (s) => {
      return (_openBlock(), _createElementBlock("div", {
        key: s.label
      }, [
        _createElementVNode("dt", _hoisted_2, _toDisplayString(s.label), 1),
        _createElementVNode("dd", {
          class: _normalizeClass(["text-base font-extrabold", s.muted ? 'text-gray-400' : 'text-gray-900'])
        }, _toDisplayString(s.value), 3)
      ]))
    }), 128))
  ]))
}
}

}